import React from "react"
import Proptypes from "prop-types"

import { Col, Row } from "reactstrap";

import ZeroErrorImage from '../../../../images/solutions/awsTerraform/Zero-error.png';
import ConvenientImage from '../../../../images/solutions/awsTerraform/Convenient.png';
import AffordableImage from '../../../../images/solutions/awsTerraform/Affordable.png';

const cardsData = [
  {
    heading: "Zero Human Errors",
    description: "Built and executed carefully for installation of Jitsi meet in AWS (Amazon web services), GCP (Google Cloud Platform), Microsoft Azure cloud infrastructure",
    image: ZeroErrorImage,
  },
  {
    heading: "Convenient",
    description: "Save time and the hassle of coding from scratch. Our ready made codified APIs into declarative configuration files and scripts are here to help you.",
    image: ConvenientImage,
  },
  {
    heading: "Affordable",
    description: "Budget friendly Terraform script in hand to build a complete video conferencing platform for your business entity.",
    image: AffordableImage,
  },
]

const CardGrid = props => {
  return (
    <div className="card-grid-wrapper">
      <h2 className="heading large-font">Easy set up of Video Conferencing platforms<br />with ready made scripts.</h2>
      <h3 className="description small-font">Explanatory guides help you build infrastructure easily. Save time coding with our pre-built Kubernetes scripts that support deploying Jitsi Meet in AWS, GCP or Azure.</h3>
      <Row>
        {cardsData.map((data)=>{
          return (
            <Col md={4}>
              <div className="grid-card">
                <img src={data.image} />
                <div className="heading medium-font">{data.heading}</div>
                <div className="description small-font">{data.description}</div>
              </div>
            </Col>
          )
        })}
      </Row>
    </div>
  )
}



export default CardGrid
